(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "reactDOM", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["CategoryPageEditorMode"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["CategoryPageEditorMode"] = factory(root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__751__, __WEBPACK_EXTERNAL_MODULE__3202__, __WEBPACK_EXTERNAL_MODULE__6252__) => {
return 